import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { LiveVideoTile, MapTile, TWCText } from '@components';

import { menuTestIDs, myWeatherPageTestIDs, Theme } from '@constants';
import { useAppContextNodeHandle, useContextNodeHandles } from '@hooks';

import { styles } from './styles';

const tPath = 'myWeatherPage.';

export const MyWeatherTopRow = () => {
  const { t } = useTranslation();

  const menuHandle = useAppContextNodeHandle(menuTestIDs.mainMenu);

  const [
    liveVideoPlayerTileHandle,
    currentWeatherConditionsTileHandle,
    dailyWeatherConditionsTileHandle,
    liveMapTileHandle,
  ] = useContextNodeHandles([
    myWeatherPageTestIDs.liveVideoPlayerTile,
    myWeatherPageTestIDs.currentWeatherConditionsTile,
    myWeatherPageTestIDs.dailyForecastTile,
    myWeatherPageTestIDs.liveMapTile,
  ]);

  return (
    <View style={styles.topRowWrapper}>
      <View style={styles.rowWrapper}>
        <View>
          <TWCText
            importantForAccessibility={'no'}
            style={styles.tileHeader}
            testID={myWeatherPageTestIDs.liveVideoPlayerHeader}
            variant={'tileHeader'}
          >
            {t(`${tPath}liveVideoPlayer.header`)}
          </TWCText>
          <LiveVideoTile.API
            height={522}
            nextFocusDown={currentWeatherConditionsTileHandle}
            nextFocusRight={liveMapTileHandle}
            nextFocusUp={menuHandle}
            translation={{ x: Theme.px(90), y: Theme.px(118) }}
            width={928}
          />
        </View>
        <View>
          <TWCText
            importantForAccessibility={'no'}
            style={styles.tileHeader}
            testID={myWeatherPageTestIDs.liveMapHeader}
            variant={'tileHeader'}
          >
            {t(`${tPath}liveMap.header`)}
          </TWCText>
          <MapTile.UI
            nextFocusDown={dailyWeatherConditionsTileHandle}
            nextFocusLeft={liveVideoPlayerTileHandle}
            nextFocusUp={menuHandle}
            testID={myWeatherPageTestIDs.liveMapTile}
          />
        </View>
      </View>
    </View>
  );
};
